module.exports = __webpack_public_path__ + "static/media/zh-HK.3f7b1a92.jpg";